import {
	ExternalLinkFragmentFragment,
	InternalLinkFragmentFragment,
} from "src/__generated__/cms-schema.codegen";

type Link = InternalLinkFragmentFragment | ExternalLinkFragmentFragment;

type Page = InternalLinkFragmentFragment["page"];

const getHref = (page: Page) => {
	switch (page.__typename) {
		case "ProductPageRecord":
			if (page.productCategory) {
				return `/${page.productFamily.slug}/${page.productCategory.slug}/${page.slug}`;
			}

			return `/${page.productFamily.slug}/${page.slug}`;
		case "PageRecord":
			return `/${page.slug}`;
		default:
			return "/";
	}
};

export const getLinkProps = (link: Link) => {
	if (link.__typename === "ExternalLinkRecord") {
		return {
			label: link.label,
			href: link.url,
		};
	}

	return {
		label: link.label,
		href: getHref(link.page),
	};
};

// 🔬 TBD
